module.exports = __webpack_public_path__ + "img/login_logo.f2cc4e9c.svg";